import { useState } from 'react'

import { pagarSuscripcion } from '../components/servicios/mercadoPagoService'
import { toastErrorLog } from '../helpers/toastErrorLog'

export const RESULTADO_PAGO = {
  REDIRIGIDO: 'REDIRIGIDO',
  PIDE_EMAIL: 'PIDE_EMAIL',
  ERROR: 'ERROR'
}

/**
 * Inicia el pago de la suscripción de exposición de una publicación y redirige a Mercado Pago.
 *
 * @returns {{abonar: Function, iniciando: boolean, emailPedido: Object|null, cancelarPedidoDeEmail: Function}}
 */
export const useAbonarSuscripcion = () => {
  const [iniciando, setIniciando] = useState(false)
  const [emailPedido, setEmailPedido] = useState(null)

  const cancelarPedidoDeEmail = () => setEmailPedido(null)

  const abonar = async (idPublicacion, payerEmail = null) => {
    try {
      setIniciando(true)
      setEmailPedido(null)

      const { data } = await pagarSuscripcion({ idPublicacion, payerEmail })
      const { initPoint, requiereEmailMP, emailSugerido } = data?.body ?? {}

      if (requiereEmailMP) {
        setEmailPedido({ idPublicacion, emailSugerido })
        setIniciando(false)

        return RESULTADO_PAGO.PIDE_EMAIL
      }

      if (!initPoint) {
        throw new Error('Mercado Pago no devolvió una URL de pago')
      }
      window.location.assign(initPoint)

      return RESULTADO_PAGO.REDIRIGIDO
    } catch (error) {
      toastErrorLog(error, 'Ocurrió un error al iniciar el pago del aviso.', 'publicaciones')
      setIniciando(false)

      return RESULTADO_PAGO.ERROR
    }
  }

  return { abonar, iniciando, emailPedido, cancelarPedidoDeEmail }
}
